import React, { Component } from 'react';

export default class NullChart extends Component {	
	render() {	
    return (
	  <div>
	  </div>
    );
  }
};